import { render, staticRenderFns } from "./ResolutionsCatalogTable.vue?vue&type=template&id=78eceea4&"
import script from "./ResolutionsCatalogTable.vue?vue&type=script&lang=js&"
export * from "./ResolutionsCatalogTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports